export default {
  PETRUHA_ONLINE_CONTENT_LOADING_IN_PROCESS: 'PETRUHA_ONLINE_CONTENT_LOADING_IN_PROCESS',
  PETRUHA_ONLINE_CONTENT_LOADING_SUCCESS: 'PETRUHA_ONLINE_CONTENT_LOADING_SUCCESS',
  PETRUHA_ONLINE_CONTENT_LOADING_FAILED: 'PETRUHA_ONLINE_CONTENT_LOADING_FAILED',
};
